/**
 * ResourcesFilters functionality
 * @class
 */
export default class ResourcesFilters {
    /**
     * @constructor
     * @param {HTMLElement} element The ResourcesFilters root element
     */
    constructor(element) {
        var _a, _b;
        this.el = element;
        this.components = {
            typeFilter: this.el.querySelector('[data-component="ResourceTypeFilter"]'),
            allOtherFilters: this.el.querySelectorAll('[data-component="ResourceOtherFilter"]'),
            dropdowns: this.el.querySelectorAll('[data-component="FilterDropdown"]'),
        };
        const checkboxesInTypeFilter = [];
        const checkboxesInThisTypeFilter = (_a = document.querySelector('[data-component="ResourceTypeFilter"]')) === null || _a === void 0 ? void 0 : _a.querySelectorAll("[type='checkbox']");
        if (checkboxesInThisTypeFilter) {
            checkboxesInThisTypeFilter.forEach((aCheckbox) => checkboxesInTypeFilter.push(aCheckbox));
        }
        const checkboxesInAllOtherFilters = [];
        this.components.allOtherFilters.forEach((otherFilterElem) => {
            const checkboxesInThisOtherFilter = otherFilterElem.querySelectorAll("[type='checkbox']");
            checkboxesInThisOtherFilter.forEach((aCheckbox) => checkboxesInAllOtherFilters.push(aCheckbox));
        });
        const addFilterToSearchParams = (checkbox, params) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const urlBase = window.location.pathname;
            const page = params.pageSearchParams != null ? `page=${params.pageSearchParams}` : "";
            const searchTerm = params.searchTermSearchParams != null ? `&searchTerm=${params.searchTermSearchParams}` : "";
            const orderby = params.orderBySearchParams != null ? `&orderby=${params.orderBySearchParams}` : "";
            /*
            * if checkbox is a resourceType filter, we need to treat it differently than all other filters since:
                1. its checkbox value isn't what we'll put in the url
                2. we'll be changing the resourceTypes search param of the url rather than the filters search param
            */
            const checkboxIsAResourceTypeFilter = checkbox.closest('[data-component="ResourceTypeFilter"]') != null;
            if (checkboxIsAResourceTypeFilter) {
                const filters = params.filterSearchParams != null ? `&filters=${params.filterSearchParams}` : "";
                if (params.resourceTypesSearchParams === null || params.resourceTypesSearchParams === '') {
                    const newUrl = `${urlBase}?${page}${searchTerm}${filters}${orderby}&resourceTypes=${(_d = (_c = (_b = (_a = checkbox.nextElementSibling) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.nextElementSibling) === null || _c === void 0 ? void 0 : _c.textContent) !== null && _d !== void 0 ? _d : ""}`;
                    window.location.replace(newUrl);
                }
                else {
                    const resourceTypes = params.resourceTypesSearchParams != null ? `&resourceTypes=${params.resourceTypesSearchParams}|${(_h = (_g = (_f = (_e = checkbox.nextElementSibling) === null || _e === void 0 ? void 0 : _e.nextElementSibling) === null || _f === void 0 ? void 0 : _f.nextElementSibling) === null || _g === void 0 ? void 0 : _g.textContent) !== null && _h !== void 0 ? _h : ""}` : `&resourceTypes=${(_l = (_k = (_j = checkbox.nextElementSibling) === null || _j === void 0 ? void 0 : _j.nextElementSibling) === null || _k === void 0 ? void 0 : _k.textContent) !== null && _l !== void 0 ? _l : ""}`;
                    const newUrl = `${urlBase}?${page}${searchTerm}${resourceTypes}${orderby}${filters}`;
                    window.location.replace(newUrl);
                }
            }
            if (!checkboxIsAResourceTypeFilter) {
                const resourceTypes = params.resourceTypesSearchParams != null ? `&resourceTypes=${params.resourceTypesSearchParams}` : "";
                if (params.filterSearchParams == null || params.filterSearchParams.length == 0) {
                    const newUrl = `${urlBase}?${page}${searchTerm}${resourceTypes}${orderby}&filters=${checkbox.value}`;
                    window.location.replace(newUrl);
                }
                else {
                    const filters = params.filterSearchParams != null ? `&filters=${params.filterSearchParams}|${checkbox.value}` : `&filters=${checkbox.value}`;
                    const newUrl = `${urlBase}?${page}${searchTerm}${resourceTypes}${orderby}${filters}`;
                    window.location.replace(newUrl);
                }
            }
        };
        const removeFilterFromSearchParams = (filterToRemove, params) => {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            const urlBase = window.location.pathname;
            const page = params.pageSearchParams != null ? `page=${params.pageSearchParams}` : "";
            const searchTerm = params.searchTermSearchParams != null ? `&searchTerm=${params.searchTermSearchParams}` : "";
            const orderby = params.orderBySearchParams != null ? `&orderby=${params.orderBySearchParams}` : "";
            const resourceTypeFilterLabels = ((_a = this.components.typeFilter) === null || _a === void 0 ? void 0 : _a.querySelectorAll('[data-component="ResourceTypeFilterLabel"]')) || [];
            const possibleResourceTypes = [...resourceTypeFilterLabels].map((label) => label.getAttribute('data-resource-type'));
            const filterToRemoveIsAResourceTypeFilter = possibleResourceTypes.includes(filterToRemove);
            if (filterToRemoveIsAResourceTypeFilter) {
                const filters = params.filterSearchParams != null ? `&filters=${params.filterSearchParams}` : "";
                let resourceTypes;
                if (((_b = params.resourceTypesSearchParams) === null || _b === void 0 ? void 0 : _b.startsWith(filterToRemove)) && params.resourceTypesSearchParams.includes("|")) {
                    resourceTypes = (_c = params.resourceTypesSearchParams) === null || _c === void 0 ? void 0 : _c.replace(`${filterToRemove}|`, "");
                }
                else if (((_d = params.resourceTypesSearchParams) === null || _d === void 0 ? void 0 : _d.startsWith(filterToRemove)) && !params.resourceTypesSearchParams.includes("|")) {
                    resourceTypes = (_e = params.resourceTypesSearchParams) === null || _e === void 0 ? void 0 : _e.replace(`${filterToRemove}`, "");
                }
                else {
                    resourceTypes = (_f = params.resourceTypesSearchParams) === null || _f === void 0 ? void 0 : _f.replace(`|${filterToRemove}`, "");
                }
                const newUrl = `${urlBase}?${page}${searchTerm}${filters}${orderby}&resourceTypes=${resourceTypes}`;
                window.location.replace(newUrl);
            }
            if (!filterToRemoveIsAResourceTypeFilter) {
                const resourceTypes = params.resourceTypesSearchParams != null ? `&resourceTypes=${params.resourceTypesSearchParams}` : "";
                let filters;
                if (((_g = params.filterSearchParams) === null || _g === void 0 ? void 0 : _g.startsWith(filterToRemove)) && params.filterSearchParams.includes("|")) {
                    filters = (_h = params.filterSearchParams) === null || _h === void 0 ? void 0 : _h.replace(`${filterToRemove}|`, "");
                }
                else if (((_j = params.filterSearchParams) === null || _j === void 0 ? void 0 : _j.startsWith(filterToRemove)) && !params.filterSearchParams.includes("|")) {
                    filters = (_k = params.filterSearchParams) === null || _k === void 0 ? void 0 : _k.replace(`${filterToRemove}`, "");
                }
                else {
                    filters = (_l = params.filterSearchParams) === null || _l === void 0 ? void 0 : _l.replace(`|${filterToRemove}`, "");
                }
                const newUrl = `${urlBase}?${page}${searchTerm}${resourceTypes}${orderby}&filters=${filters}`;
                window.location.replace(newUrl);
            }
        };
        const updateFiltersSearchParams = (event) => {
            var _a, _b, _c, _d;
            const checkbox = event.target;
            const searchParams = new URLSearchParams(window.location.search);
            const pageSearchParams = searchParams.get("page");
            const searchTermSearchParams = searchParams.get("searchTerm");
            const orderBySearchParams = searchParams.get("orderby");
            const resourceTypesSearchParams = searchParams.get("resourceTypes");
            const filterSearchParams = searchParams.get("filters");
            const params = { searchParams, pageSearchParams, searchTermSearchParams, orderBySearchParams, resourceTypesSearchParams, filterSearchParams };
            if (checkbox.checked) {
                addFilterToSearchParams(checkbox, params);
            }
            else {
                /*
                * if checkbox is a resourceType filter, we need to treat it differently than all other filters since its checkbox value isn't what we'll remove from the url
                */
                const checkboxIsAResourceTypeFilter = checkbox.closest('[data-component="ResourceTypeFilter"]') != null;
                const filterToRemove = checkboxIsAResourceTypeFilter ? (_d = (_c = (_b = (_a = checkbox.nextElementSibling) === null || _a === void 0 ? void 0 : _a.nextElementSibling) === null || _b === void 0 ? void 0 : _b.nextElementSibling) === null || _c === void 0 ? void 0 : _c.textContent) !== null && _d !== void 0 ? _d : "" : checkbox.value;
                removeFilterFromSearchParams(filterToRemove, params);
            }
        };
        checkboxesInAllOtherFilters.forEach((checkbox) => {
            const theCheckbox = checkbox;
            theCheckbox.addEventListener("change", updateFiltersSearchParams);
        });
        checkboxesInTypeFilter.forEach((checkbox) => {
            const theCheckbox = checkbox;
            theCheckbox.addEventListener("change", updateFiltersSearchParams);
        });
        const updateCount = () => {
            checkboxesInTypeFilter.forEach((aCheckbox) => {
                var _a;
                const theCheckbox = aCheckbox;
                const countElement = (_a = theCheckbox.closest('[data-component="ResourceTypeFilter"]')) === null || _a === void 0 ? void 0 : _a.querySelector('[data-component="ResourceTypeFilterCount"]');
                if (theCheckbox.checked && countElement) {
                    countElement === null || countElement === void 0 ? void 0 : countElement.classList.remove("resource-filters__count--hidden");
                    countElement.textContent = (countElement === null || countElement === void 0 ? void 0 : countElement.textContent) == "" ? "1" : String(Number(countElement === null || countElement === void 0 ? void 0 : countElement.textContent) + 1);
                }
            });
            checkboxesInAllOtherFilters.forEach((aCheckbox) => {
                var _a;
                const theCheckbox = aCheckbox;
                const countElement = (_a = theCheckbox.closest('[data-component="ResourceOtherFilter"]')) === null || _a === void 0 ? void 0 : _a.querySelector('[data-component="ResourceOtherFilterCount"]');
                if (theCheckbox.checked && countElement) {
                    countElement === null || countElement === void 0 ? void 0 : countElement.classList.remove("resource-filters__count--hidden");
                    countElement.textContent = (countElement === null || countElement === void 0 ? void 0 : countElement.textContent) == "" ? "1" : String(Number(countElement === null || countElement === void 0 ? void 0 : countElement.textContent) + 1);
                }
            });
        };
        updateCount();
        const clearAllActiveFiltersBtn = document.querySelector('[data-component="ResourcesClearAllActiveFilters"]');
        const hideOrShowClearAllActiveFiltersBtn = () => {
            const searchParams = new URLSearchParams(window.location.search);
            const resourceTypesSearchParams = searchParams.get("resourceTypes");
            const filterSearchParams = searchParams.get("filters");
            const thereAreNoCurrentlyActiveResourceTypeFilters = (resourceTypesSearchParams === null || resourceTypesSearchParams === void 0 ? void 0 : resourceTypesSearchParams.length) == 0 && resourceTypesSearchParams == "";
            const thereAreNoCurrentlyActiveOtherFilters = (filterSearchParams === null || filterSearchParams === void 0 ? void 0 : filterSearchParams.length) == 0 && filterSearchParams == "";
            if (thereAreNoCurrentlyActiveResourceTypeFilters && thereAreNoCurrentlyActiveOtherFilters) {
                clearAllActiveFiltersBtn === null || clearAllActiveFiltersBtn === void 0 ? void 0 : clearAllActiveFiltersBtn.classList.add("isHidden");
            }
            else {
                clearAllActiveFiltersBtn === null || clearAllActiveFiltersBtn === void 0 ? void 0 : clearAllActiveFiltersBtn.classList.remove("isHidden");
            }
        };
        hideOrShowClearAllActiveFiltersBtn();
        const clearAllActiveFilters = () => {
            const urlBase = window.location.pathname;
            const searchParams = new URLSearchParams(window.location.search);
            const pageSearchParams = searchParams.get("page");
            const searchTermSearchParams = searchParams.get("searchTerm");
            const orderBySearchParams = searchParams.get("orderby");
            const page = pageSearchParams != null ? `page=${pageSearchParams}` : "";
            const searchTerm = searchTermSearchParams != null ? `&searchTerm=${searchTermSearchParams}` : "";
            const orderby = orderBySearchParams != null ? `&orderby=${orderBySearchParams}` : "";
            const newUrl = `${urlBase}?${page}${searchTerm}${orderby}`;
            window.location.replace(newUrl);
        };
        clearAllActiveFiltersBtn === null || clearAllActiveFiltersBtn === void 0 ? void 0 : clearAllActiveFiltersBtn.addEventListener("click", clearAllActiveFilters);
        const addActiveFiltersToThePage = () => {
            var _a, _b;
            const searchParams = new URLSearchParams(window.location.search);
            const resourceTypesSearchParams = (_a = searchParams.get("resourceTypes")) === null || _a === void 0 ? void 0 : _a.split("|");
            const filterSearchParams = (_b = searchParams.get("filters")) === null || _b === void 0 ? void 0 : _b.split("|");
            const activeFiltersElement = document.querySelector('[data-component="ResourcesActiveFilters"]');
            if (resourceTypesSearchParams != null && (resourceTypesSearchParams === null || resourceTypesSearchParams === void 0 ? void 0 : resourceTypesSearchParams.length) >= 1 && resourceTypesSearchParams[0] !== "") {
                resourceTypesSearchParams.forEach((aFilter) => {
                    const element = document.createElement("li");
                    element.className = "chips__chip";
                    element.setAttribute("aria-label", "Active filter; click to clear");
                    const span = document.createElement("span");
                    span.className = "chips__name";
                    span.textContent = aFilter;
                    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    svg.setAttribute("width", "23");
                    svg.setAttribute("height", "23");
                    svg.setAttribute("viewBox", "0 0 23 23");
                    svg.setAttribute("fill", "none");
                    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                    svg.classList.add("chips__icon");
                    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path.setAttribute("d", "m5.526 5.526 11.051 11.05m-11.051.001L16.577 5.526");
                    path.setAttribute("stroke", "#9E0000");
                    path.setAttribute("stroke-width", "3");
                    svg.appendChild(path);
                    element.appendChild(span);
                    element.appendChild(svg);
                    activeFiltersElement === null || activeFiltersElement === void 0 ? void 0 : activeFiltersElement.appendChild(element);
                });
            }
            if (filterSearchParams != null && filterSearchParams.length >= 1 && filterSearchParams[0] !== "") {
                filterSearchParams.forEach((aFilter) => {
                    const element = document.createElement("li");
                    element.className = "chips__chip";
                    element.setAttribute("aria-label", "Active filter; click to clear");
                    const span = document.createElement("span");
                    span.className = "chips__name";
                    span.textContent = aFilter;
                    const svg = document.createElementNS("http://www.w3.org/2000/svg", "svg");
                    svg.setAttribute("width", "23");
                    svg.setAttribute("height", "23");
                    svg.setAttribute("viewBox", "0 0 23 23");
                    svg.setAttribute("fill", "none");
                    svg.setAttribute("xmlns", "http://www.w3.org/2000/svg");
                    svg.classList.add("chips__icon");
                    const path = document.createElementNS("http://www.w3.org/2000/svg", "path");
                    path.setAttribute("d", "m5.526 5.526 11.051 11.05m-11.051.001L16.577 5.526");
                    path.setAttribute("stroke", "#9E0000");
                    path.setAttribute("stroke-width", "3");
                    svg.appendChild(path);
                    element.appendChild(span);
                    element.appendChild(svg);
                    activeFiltersElement === null || activeFiltersElement === void 0 ? void 0 : activeFiltersElement.appendChild(element);
                });
            }
        };
        addActiveFiltersToThePage();
        const activeFilterBtns = (_b = document.querySelector('[data-component="ResourcesActiveFilters"]')) === null || _b === void 0 ? void 0 : _b.querySelectorAll("li");
        const removeFilterFromSearchParamsUsingActiveFilterBtnX = (event) => {
            var _a;
            event.stopPropagation();
            const theElement = event.target;
            let theFilterToRemove;
            if (theElement.innerText !== undefined) {
                theFilterToRemove = theElement.innerText;
            }
            else {
                theFilterToRemove = (_a = theElement.closest("li")) === null || _a === void 0 ? void 0 : _a.innerText;
            }
            const searchParams = new URLSearchParams(window.location.search);
            const pageSearchParams = searchParams.get("page");
            const searchTermSearchParams = searchParams.get("searchTerm");
            const orderBySearchParams = searchParams.get("orderby");
            const resourceTypesSearchParams = searchParams.get("resourceTypes");
            const filterSearchParams = searchParams.get("filters");
            const params = { searchParams, pageSearchParams, searchTermSearchParams, orderBySearchParams, resourceTypesSearchParams, filterSearchParams };
            if (theFilterToRemove !== undefined && theFilterToRemove !== null && theFilterToRemove !== "") {
                removeFilterFromSearchParams(theFilterToRemove, params);
            }
        };
        activeFilterBtns === null || activeFilterBtns === void 0 ? void 0 : activeFilterBtns.forEach((anActiveFilterBtn) => {
            anActiveFilterBtn.addEventListener("click", removeFilterFromSearchParamsUsingActiveFilterBtnX);
        });
        this.components.dropdowns.forEach((D, _, A) => {
            D.ontoggle = _ => { if (D.open)
                A.forEach(d => { if (d != D)
                    d.open = false; }); };
        });
        // console.log('ResourcesFilters', this);
    }
    /**
     * Creates new instances of IResourcesFiltersUtils for each `[data-component="ResourcesFilters"]` element
     */
    static init() {
        const ResourcesFiltersEl = document.querySelector('[data-component="ResourcesFilters"]');
        if (ResourcesFiltersEl) {
            const ResourcesFiltersUtil = new ResourcesFilters(ResourcesFiltersEl);
        }
    }
}
